import { render, staticRenderFns } from "./SubTestLevelTitle.vue?vue&type=template&id=05c47a74&scoped=true&"
import script from "./SubTestLevelTitle.vue?vue&type=script&lang=js&"
export * from "./SubTestLevelTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubTestLevelTitle.vue?vue&type=style&index=0&id=05c47a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c47a74",
  null
  
)

export default component.exports